<div class="login-container">
  <div class="login-card">
    <div class="welcome-text">
      <img ngSrc="logo.svg" priority alt="Suburban Supply Logo" class="logo" height="236" width="236" />
      <h1>Welcome to Suburban Supply.</h1>
    </div>
    <app-button label="Sign In" styleClass="login-btn" (click)="login()"></app-button>
  </div>
</div>
